module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-ext_latin-500.15431381.woff2";